import { BatchActions, Boards, Distribution, Postings } from 'src/api';

export interface DistributionStateInterface {
  dayOffset: number;
  executions: Distribution.Types.Execution[];
  boards: Boards.Types.Board[];
  includeLocalOutreach: boolean;
  postings: Postings.Types.Posting[];
  boardBatchActionExecutions: {
    [arn: string]: BatchActions.Types.BatchActionExecutionRecord;
  };
}

export default function (): DistributionStateInterface {
  return {
    dayOffset: 0,
    executions: [],
    boards: [],
    includeLocalOutreach: false,
    postings: [],
    boardBatchActionExecutions: {},
  };
}
